/**
 * Utility functions for ProjectTemplateCard
 */

/**
 * Generates the project template name based on state
 * @param {Array} projectTemplateGroup - Array of template versions
 * @param {boolean} showVersions - Whether versions are currently shown
 * @returns {string} Formatted template name
 */
export const getProjectTemplateName = (projectTemplateGroup, showVersions) => {
  if (!projectTemplateGroup || projectTemplateGroup.length === 0) {
    return '';
  }
  
  const baseName = projectTemplateGroup[projectTemplateGroup.length - 1].name;
  return showVersions ? baseName : `${baseName} (${projectTemplateGroup.length})`;
};

/**
 * Sorts template versions by version number (descending)
 * @param {Array} projectTemplateGroup - Array of template versions
 * @returns {Array} Sorted array of templates
 */
export const getSortedTemplateVersions = (projectTemplateGroup) => {
  if (!projectTemplateGroup) return [];
  
  return [...projectTemplateGroup].sort((t1, t2) => t2.version - t1.version);
};

/**
 * Checks if a template is the selected one
 * @param {Object} template - Template to check
 * @param {Object} selectedTemplate - Currently selected template
 * @returns {boolean} Whether template is selected
 */
export const isTemplateSelected = (template, selectedTemplate) => {
  return selectedTemplate && selectedTemplate.id === template.id;
};

/**
 * Checks if delete icon should be shown for a template version
 * @param {Object} template - Template to check
 * @param {Object} projectTemplateGroup - Array of all templates
 * @param {boolean} hoveredOver - Whether card is hovered
 * @returns {boolean} Whether delete icon should be shown
 */
export const shouldShowDeleteIcon = (template, projectTemplateGroup, hoveredOver) => {
  return hoveredOver && 
         projectTemplateGroup[0] && 
         projectTemplateGroup[0].id === template.id && 
         template.version !== 1;
};

/**
 * Handles event propagation stopping
 * @param {Event} event - The event to handle
 */
export const stopEventPropagation = (event) => {
  if (event) {
    event.stopPropagation();
  }
};



// WEBPACK FOOTER //
// ./src/containers/ProjectTypesContainer/ProjectTemplateCard/utils/templateUtils.js